// src/routes/PublicRoutes.tsx
import { RouteObject } from 'react-router-dom';
import { Suspense } from 'react';

import Home from '../pages/Home';
import About from '../pages/About';
import Contact from '../pages/Contact';
import BlogList from '../pages/BlogList';
import BlogDetail from '../pages/BlogDetail';
import ToolDetailPage from '../pages/ToolDetailPage';
import NotFound from '../pages/NotFound';
import RedirectToToolWithCategory from '../pages/RedirectToToolWithCategory';
import CategoryPage from '../pages/CategoryPage';
import CategoryToolsPage from '../pages/CategoryToolsPage';
import FeaturedToolsPage from '../pages/FeaturedToolsPage';
import SearchPage from '../pages/SearchPage';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import CookiePolicy from '../pages/CookiePolicy';
import Tools from '../pages/Tools'; // Add the 404 page for tools
import CompareTools from '../pages/CompareTools'; // Add compare tools page
import AlphabetToolsPage from '../pages/AlphabetToolsPage';
import SubmitAIToolForm  from '../pages/SubmitToolForm';
import AdvertisePage from '../pages/AdvertisePage';
import ChatPage from '../pages/ChatPage';

// Loading component for better UX
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-purple-200 border-t-purple-600 rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-gray-600 dark:text-gray-400">Loading amazing AI tools...</p>
    </div>
  </div>
);

// Route definitions
const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: '/tools',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <Tools /> {/* This handles the /tools 404 with beautiful design */}
      </Suspense>
    ),
  },
  {
    path: '/tools/featured/:toolId',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <FeaturedToolsPage />
      </Suspense>
    ),
  },
  {
    path: '/tools/:toolId', // 👈 old URL structure (backward compatibility)
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <RedirectToToolWithCategory />
      </Suspense>
    ),
  },
  {
    path: '/tools/:category/:toolId',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ToolDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/categories/:category',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CategoryToolsPage />
      </Suspense>
    ),
  },
  {
    path: '/categories',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CategoryPage />
      </Suspense>
    ),
  },
  {
    path: '/search',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <SearchPage />
      </Suspense>
    ),
  },
  {
    path: '/compare',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CompareTools />
      </Suspense>
    ),
  },
  {
    path: '/about',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <About />
      </Suspense>
    ),
  },
  {
    path: '/contact',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <Contact />
      </Suspense>
    ),
  },
  {
    path: '/blog',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <BlogList />
      </Suspense>
    ),
  },
  {
    path: '/blog/:slug',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <BlogDetail />
      </Suspense>
    ),
  },
  {
    path: '/privacy-policy',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <PrivacyPolicy />
      </Suspense>
    ),
  },
  {
    path: '/terms-of-service',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <TermsOfService />
      </Suspense>
    ),
  },
  {
    path: '/cookie-policy',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CookiePolicy />
      </Suspense>
    ),
  },
  // Redirect old policy URLs to new ones
  {
    path: '/terms',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <TermsOfService />
      </Suspense>
    ),
  },
  {
    path: '/cookies',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CookiePolicy />
      </Suspense>
    ),
  },
  {
    path: '/alphabet',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AlphabetToolsPage />
      </Suspense>
    ),
  },
  {
    path: '/alphabet/:letter',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AlphabetToolsPage />
      </Suspense>
    ),
  },
    {
    path: '/submit-tool',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <SubmitAIToolForm />
      </Suspense>
    ),
  },
  {
    path: '/advertise',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AdvertisePage />
      </Suspense>
    ),
  },
  {
    path: '/chat',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ChatPage />
      </Suspense>
    ),
  },

  // 404 catch-all route (must be last)
  {
    path: '*',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default publicRoutes;
